import { gql } from '@apollo/client';

const query = gql`
  query GetReviewListingAggregates(
    $categoryId: String
    $suburbName: String
    $state: String
    $region: String
    $market: String
    $first: Int
  ) {
    reviewListingAggregates(
      categoryId: $categoryId
      suburbName: $suburbName
      state: $state
      region: $region
      market: $market
      first: $first
    ) {
      edges {
        node {
          averageRating
          count
          listing {
            profileUrl
            vanityUrlPath
            name
            hash
            online
            displayReviews
            listingAssets {
              url
            }
            listingCategories {
              primaryCategory
              category {
                name
              }
            }
            listingLocations {
              primaryLocation
              suburb {
                name
                state
              }
            }
          }
        }
      }
    }
  }
`;

module.exports = query;
